// extracted by mini-css-extract-plugin
export default {"link":"style_link__1jYnO","text":"style_text__tEg8V","active":"style_active__bpSye"};